/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback Reserve Modal styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const CashbackReserveModalBodyStyled = styled.div.attrs({
    className: 'cashback-reserve-modal__body',
})`
    max-width: 320px;
    margin-top: 32px;

    div.cashback-reserve-modal__score-input {
        margin-bottom: 10px;
    }

    .cashback-reserve-modal__reserve-checkbox {
        align-items: center;
        margin-left: 6px;
        ${fonts.textSmall};
    }
`;

export const CashbackReserveModalStatusStyled = styled.div.attrs({
    className: 'cashback-reserve-modal__status',
})`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .modal-popup-title {
        margin-top: 32px;
    }
`;
